'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { Fragment, useState } from 'react';
import styled from 'styled-components';
import ProductCatalogTableCell from 'ui-addon-upgrades/_core/productCatalog/ProductCatalogTableCell';
import ProductCatalogTableTitle from 'ui-addon-upgrades/_core/productCatalog/ProductCatalogTableTitle';
const FeatureName = styled.div.withConfig({
  displayName: "SuiteCatalogTableCell__FeatureName",
  componentId: "sc-1hnqgaa-0"
})(["padding:10px 0;display:inline-block;& > p{margin-left:8px;margin-bottom:0;font-weight:500;display:inline-block;}text-align:left;"]);

const SuiteCatalogTableCell = ({
  productLine,
  productLevel,
  featureId
}) => {
  const [width] = useState(window.innerWidth);
  const showTooltip = width >= 800;
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx("td", {
      className: "p-left-8",
      style: {
        width: '27%'
      },
      children: /*#__PURE__*/_jsx(FeatureName, {
        children: featureId && /*#__PURE__*/_jsx(ProductCatalogTableTitle, {
          featureId: featureId,
          productLine: productLine,
          showTooltip: showTooltip
        })
      })
    }), /*#__PURE__*/_jsx(ProductCatalogTableCell, {
      featureId: featureId,
      productLine: productLine,
      showTooltip: showTooltip,
      allProductLevels: [productLevel],
      currentProductLevel: productLevel,
      hasFeature: true
    })]
  });
};

SuiteCatalogTableCell.propTypes = {
  featureId: PropTypes.string,
  productLine: PropTypes.string.isRequired,
  productLevel: PropTypes.string.isRequired
};
export default SuiteCatalogTableCell;